export function sanitize (str) {
    str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, '');

    return str.trim();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/sanitize.ts